import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { Photos, Videos, Panoramas, Description, WalkingPhotos } from '.'
import { useMediaDetails } from 'Hooks/useMediaDetails'
import { getWalkingPoints } from 'Hooks/getWalkingPoints'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface SupplementalMediaProps {
  stopId?: number
}

const SupplementalMedia = ({ stopId }: SupplementalMediaProps) => {
  const {
    photos,
    photoAssetUrl,
    videos,
    panoramas,
    panoAssetUrl,
    photoHotspots,
    videoHotspots,
    panoHotspots,
    textHotspots,
    photoPosMedia,
    videoPosMedia,
    panoPosMedia,
  } = useMediaDetails(stopId)

  const { walkingPoints } = getWalkingPoints(stopId)

  const combinedPhotos =
    photos && photoHotspots && photoPosMedia
      ? [...photos, ...photoHotspots, ...photoPosMedia]
      : []
  const combinedVideos =
    videos && videoHotspots && videoPosMedia
      ? [...videos, ...videoHotspots, ...videoPosMedia]
      : []
  const combinedPanoramas =
    panoramas && panoHotspots && panoPosMedia
      ? [...panoramas, ...panoHotspots, ...panoPosMedia]
      : []

  return (
    <>
      {combinedPhotos.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            Photos
          </AccordionSummary>
          <AccordionDetails>
            <Photos photos={combinedPhotos} assetUrl={photoAssetUrl} />
          </AccordionDetails>
        </Accordion>
      )}

      {combinedVideos.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            Videos
          </AccordionSummary>
          <AccordionDetails>
            <Videos videos={combinedVideos} />
          </AccordionDetails>
        </Accordion>
      )}

      {combinedPanoramas.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            Panoramas
          </AccordionSummary>
          <AccordionDetails>
            <Panoramas panoramas={combinedPanoramas} assetUrl={panoAssetUrl} />
          </AccordionDetails>
        </Accordion>
      )}

      {textHotspots?.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            Descriptions
          </AccordionSummary>
          <AccordionDetails>
            <Description hotspots={textHotspots} />
          </AccordionDetails>
        </Accordion>
      )}

      {walkingPoints.stopPoints.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            Walking Points
          </AccordionSummary>
          <AccordionDetails>
            <p tabIndex={0}>You are now walking to the next stop experience.</p>
            <WalkingPhotos
              walkingPoints={walkingPoints}
              assetUrl={photoAssetUrl}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}

export default SupplementalMedia
